export default "__VITE_ASSET__7561a3e3__"